// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — rack-event.classic.js, новая — rack-event.cp.js
import { isCp } from 'libs/design';
import * as classic from './rack-event.classic';
import * as cp from './rack-event.cp';

export const RackEvent = isCp ? cp.RackEvent : classic.RackEvent;
